// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2oHl4","icon":"SortAdornment_icon__WOSaf","up":"SortAdornment_up__1Qufg","down":"SortAdornment_down__Tk1PB","active":"SortAdornment_active__12HFJ"};